@if (isVisible()) {
  @if (singleDestination(); as destination) {
    <!-- 99% of cases: Direct 1-click switch button -->
    <a
      matButton
      class="link small gap-x-1.5"
      [href]="destination.url"
      [matTooltip]="destination.tooltip"
      [attr.aria-label]="destination.label"
    >
      <span class="hidden sm:inline font-medium text-xs">{{ destination.label }}</span>
      <span class="sm:hidden font-medium text-xs">{{ destination.shortLabel }}</span>
    </a>
  } @else if (hasMultipleDestinations()) {
    <!-- Multi-profile case or new user without profile yet: Dropdown menu -->
    <button
      matButton
      class="secondary small gap-x-1.5"
      [matMenuTriggerFor]="spacesMenu"
      [attr.aria-label]="menuButtonLabel()"
      [matTooltip]="menuButtonLabel()"
    >
      <mat-icon svgIcon="arrow-left-right" class="text-neutral-11" />
      <span class="hidden sm:inline font-medium text-xs">{{ menuButtonLabel() }}</span>
      <span class="sm:hidden font-medium text-xs">Espaces</span>
      <mat-icon svgIcon="chevron-down" class="size-3.5! -mr-1 text-neutral-10" />
    </button>

    <mat-menu #spacesMenu="matMenu" xPosition="before" class="min-w-60!">
      <div class="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-neutral-10 select-none">
        {{ menuTitle() }}
      </div>
      @for (app of destinations(); track app.id) {
        <a mat-menu-item [href]="app.url" class="h-auto! py-2.5!">
          <mat-icon [svgIcon]="app.icon" class="text-neutral-11" />
          <div class="flex flex-col text-left">
            <span class="text-sm font-medium text-neutral-12">{{ app.label }}</span>
            <span class="text-xs text-neutral-10">{{ app.description }}</span>
          </div>
        </a>
      }
    </mat-menu>
  }
}
